import { render, staticRenderFns } from "./ModalImages.vue?vue&type=template&id=b62d41c4&lang=html&"
import script from "./ModalImages.vue?vue&type=script&lang=js&"
export * from "./ModalImages.vue?vue&type=script&lang=js&"
import style0 from "./ModalImages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports